<template>
  <component :is="couponData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="couponData === undefined">
      <h4 class="alert-heading">獲取優惠券數據時出錯</h4>
      <div class="alert-body">
        找不到相關優惠券記錄。請查看
        <b-link class="alert-link" :to="{ name: 'coupon-list' }">
          優惠券列表
        </b-link>
      </div>
    </b-alert>
    <coupon-edit-tab-information
      v-if="couponData"
      :customerOptions="customerOptions"
      :coupon-data="couponData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- :userOptions="userOptions" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import couponStoreModule from "../couponStoreModule";
import couponEditTabInformation from "./couponEditTabInformation.vue";

export default {
  components: {
    couponEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const couponData = ref({ id: 0,is_active:1 });
    const coupon = {
      id: 0,
      is_active:1
    };

    const coupon_APP_STORE_MODULE_NAME = "coupon";

    if (!store.hasModule(coupon_APP_STORE_MODULE_NAME))
      store.registerModule(coupon_APP_STORE_MODULE_NAME, couponStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(coupon_APP_STORE_MODULE_NAME))
        store.unregisterModule(coupon_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "coupon-coupon-create") {
        couponData.value = coupon;
      } else {
        store
          .dispatch("coupon/fetchCoupon", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            couponData.value = response.data.coupon;
            console.log(couponData.value);
          })
          .catch((error) => {
            console.log("error when fetching coupon", error);
            if (error.response.is_active === 404) {
              couponData.value = undefined;
            }
          });
      }
    };

  const customerOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        customers: true,
      })
      .then((response) => {
        customerOptions.value = response.data.customers;
        refetchData();
      });
  };

    onMounted(() => {
      refetchOption();
    });

    return {
      couponData,
      customerOptions,
      refetchOption,
      refetchData,
    };
  },
};
</script>
